export const DADOS_ASSOCIADO_MOCK = {
  nome: "JONATAS FERNANDES FERREIRA LACERDA",
  documento: "31673823840",
  sexo: "MASCULINO",
  dataNascimento: "2024-08-13",
};
